import React from 'react';
import { connect } from 'react-redux';
import { HashRouter, Route, Switch } from 'react-router-dom';

import PictureBrowser from './PictureBrowser';
import HomePage from './HomePage';
import PictureAdmin from './admin/PictureAdmin';
import UploadPictures from './admin/UploadPictures';
import Header from './admin/Header';

class App  extends React.Component {
    render() {
        return (
            <div>
                <HashRouter>
                    <Switch>
                        <Route path="/" exact component={HomePage} />
                        <Route 
                            path="/view/:category" 
                            exact
                            render={(props) => <PictureBrowser {...props} />}
                        />
                            <React.Fragment>
                                <Header />                
                                <Route path="/admin" exact component={PictureAdmin} />
                                <Route path="/admin/upload" exact component={UploadPictures} />
                                <Route path="/admin/delete/:pictureId" exact component={UploadPictures} />
                            </React.Fragment>
                    </Switch>
                </HashRouter>
            </div>
        );
    }

}

const mapStateToProps = (state) => {    
    return {
        isSignedIn: state.auth.isSignedIn
    }
}


export default connect(mapStateToProps)(App);